import { SagaIterator } from "redux-saga";
import { takeEvery, call, getContext, select } from "redux-saga/effects";
import { ActionsOfType } from "../../../redux/ActionHelper";
import { PageActionsType, PageActionTypes } from "./PageActions";
import { PageTelemetryLogger } from "../PageTelemetryLogger";

export function* pageSaga(): SagaIterator {
    yield takeEvery(PageActionTypes.LogTelemetry, logTelemetry);
}

export function* logTelemetry(telemetryAction: ActionsOfType<PageActionsType, PageActionTypes.LogTelemetry>): SagaIterator {
    const { feature, action, properties, errorMessage } = telemetryAction.payload;
    const pageContext = yield getContext("pageContext");

    if (pageContext) {
        var telemetryLogger: PageTelemetryLogger = new PageTelemetryLogger(pageContext, feature, action);

        try {
            if (errorMessage && errorMessage.length > 0) {
                yield call(telemetryLogger.captureError, errorMessage);
            } else {
                yield call(telemetryLogger.captureTelemetry, properties ? properties : {});
            }
        } catch (error) {
            yield call(telemetryLogger.captureError, errorMessage);
        }
    }
}
